import { useEffect, useState } from "react";
import { getSignedRevisions } from "../api/signedRevision";
import { SignedRevision } from "../models/signedRevision";
import { fetchOccurrenceListByScheduleIds } from "../api/fetchOccurence";
import { Occurrence } from "../models/occurrence";

interface IUsePeriodicReviewsProps {
    chassis: string;
    scheduleIds: string[];
    userRole: 'TOWER' | 'CONSULTANT' | 'MANAGER' | 'PARTNERSHIP';
    dialog: boolean;
}

function usePeriodicReviews({ chassis, scheduleIds, userRole, dialog }: IUsePeriodicReviewsProps) {
    const [activeTab, setActiveTab] = useState<"revisoes" | "trocaDeOleo">("revisoes");

    const [occurrenceList, setOccurrenceList] = useState<Occurrence[]>([]);
    const [signedRevisions, setSignedRevisions] = useState<SignedRevision[]>([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
            const signedRevisions = await getSignedRevisions(chassis);
            setSignedRevisions(signedRevisions);
            const occurrenceList = await fetchOccurrenceListByScheduleIds(userRole, scheduleIds.filter(Boolean));
                setOccurrenceList(occurrenceList);
            } catch (error) {
                console.error(error);
            } finally {
                setLoading(false);
            }
        };
        if(dialog) fetchData();
    }, [scheduleIds, chassis, dialog]);

    const blockchainData = (scheduleId: string): SignedRevision | undefined => {
        const occurrence = occurrenceList.find((occurrence: Occurrence) => occurrence.scheduleId === scheduleId);
        const signedRevision = signedRevisions.find((signedRevision: SignedRevision) => signedRevision.id === occurrence?.id);
        return signedRevision;
    }

    return { activeTab, setActiveTab, blockchainData, loading };
}

export default usePeriodicReviews;